import React, { useState, useEffect } from "react";

const RealTimeClock = () => {
  // State to store the current date and time
  const [currentTime, setCurrentTime] = useState(new Date());

  // Effect to update the time every minute
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Updates every 60000 milliseconds (1 minute)

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [currentTime]);

  // Format date and time
  const day = currentTime.toLocaleDateString("en-GB");
  const time = currentTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="font-semibold flex gap-4 text-yellow-500">
      <p>{` ${day}`}</p>
      <p>{` ${time}`}</p>
    </div>
  );
};

export default RealTimeClock;
